import { ptBR } from "date-fns/locale";
import { format, parseISO, addDays, startOfDay } from "date-fns";
import { Calendar } from "../ui/calendar";

export const toISO = (d) => format(d, "yyyy-MM-dd");
const WEEKDAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export const DateCalendar = ({ value, onChange, disabledDates = [], minOffset = 1, modifiers, modifiersClassNames, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-white/10 bg-white/[0.03] w-fit max-w-full">
    <Calendar
      mode="single"
      locale={ptBR}
      formatters={{ formatWeekdayName: (d) => WEEKDAYS[d.getDay()] }}
      selected={value ? parseISO(value) : undefined}
      onSelect={(d) => d && onChange(toISO(d))}
      disabled={[{ before: addDays(startOfDay(new Date()), minOffset) }, ...disabledDates.map((d) => parseISO(d))]}
      modifiers={modifiers}
      modifiersClassNames={modifiersClassNames}
      className="p-4"
      classNames={{
        caption_label: "font-display text-base capitalize text-white",
        nav_button: "h-8 w-8 grid place-items-center rounded-full border border-white/15 hover:border-[#FFD200] text-white",
        head_cell: "text-zinc-400 w-10 font-normal text-[0.75rem] capitalize",
        cell: "relative p-0 text-center text-sm",
        day: "h-10 w-10 p-0 rounded-full text-white hover:bg-white/10 transition-colors aria-selected:opacity-100",
        day_selected: "!bg-[#FFD200] !text-[#08080C] font-bold",
        day_today: "border border-white/25",
        day_disabled: "!text-zinc-600 line-through hover:bg-transparent cursor-not-allowed",
        day_outside: "text-zinc-600",
      }}
    />
  </div>
);
